import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { CellContentProps, CellRenderer } from '../../legacy-design-system/grid'
import { environmentI18nConfig } from '../servers-grid'
import { LoadingTextMask } from '../../legacy-design-system/loading-masks'
import { Route } from '../../graphql/schema/types/route'

interface RowData {
  readonly environments?: string[]
}

export const getEnvironmentsCellRenderer =
  (): CellRenderer<Route> =>
  ({ rowData, getCellContentProps }) =>
    (
      <EnvironmentsCell
        rowData={rowData}
        getCellContentProps={getCellContentProps}
      />
    )

const EnvironmentsCell = ({
  rowData: { environments },
  getCellContentProps
}: {
  rowData: RowData
  getCellContentProps: (props: {}) => CellContentProps
}) => {
  const intl = useIntl()

  return (
    <div {...getCellContentProps({})}>
      <ul
        className={css`
          list-style-type: none;
          padding: 0;
          margin: 0;
        `}
      >
        {environments?.map((environment, index) => (
          <li
            key={index}
            className={css`
              padding-bottom: 4px;
              line-height: 17px;
              z-index: 10;
            `}
          >
            {intl.formatMessage({ id: environmentI18nConfig[environment] })}
          </li>
        ))}
      </ul>
    </div>
  )
}

export const loadingEnvironmentsCell = () => <LoadingTextMask min={2} max={7} />
